import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  function getCookie(name) {
    function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : null;
}
  const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
  const isEmbed = new URLSearchParams(location.search).get('embed') === '1';
  const isAuthenticated = user && new Date().getTime() - user.loginTime < 30 * 24 * 60 * 60 * 1000;
  const isAdmin = user ? user.isAdmin : false;

  // If not authenticated, redirect to login with the intended destination
  if (!isAuthenticated && !isEmbed) {
    // Encode the current pathname and search params to preserve the full URL
    const currentUrl = location.pathname + location.search;
    const encodedUrl = encodeURIComponent(currentUrl);
    return <Navigate to={`/login?redirect=${encodedUrl}`} replace />;
  }
  if (!user && !isEmbed && location.pathname.startsWith('/call_id')) {
    const currentUrl = location.pathname + location.search;
    const encodedUrl = encodeURIComponent(currentUrl);
    return <Navigate to={`/login?redirect=${encodedUrl}`} replace />;
  }

  // If authenticated but not an admin, restrict access to admin-config by redirecting
  if (!isAdmin && location.pathname === '/admin-config') {
    return <Navigate to="/home" replace />; // Redirect non-admin users to dashboard
  }

  // If the user is authenticated and allowed, render the children
  return children;
};
 
export default ProtectedRoute;
